<template>
  <PreviewSheet background="primary" class="preview-form-group" radius="small">
    <div class="flex-col gap-6">
      <PreviewTypography variant="titleRegular" :text="title" />
      <slot />
    </div>
  </PreviewSheet>
</template>
<script lang="ts" setup>
import PreviewSheet from './PreviewSheet.vue'
import PreviewTypography from './PreviewTypography.vue'

withDefaults(
  defineProps<{
    title: string
  }>(),
  {}
)
</script>
<style lang="scss" scoped>
.preview-form-group {
  padding: 24px;
}
</style>
